import PropertyThumbListContainer from "../../../components/property/listing/PropertyThumbList";

const PropertyThumbList = () => {
  return <PropertyThumbListContainer />;
};

export default PropertyThumbList;
